import { Box, Button, Card, Modal, Text } from '@nimbus-ds/components';
import { SubmitButton } from 'commons/components';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { ChangePlanModalProps } from '../../ChangePlanModal';
import PlanChangeVisual from '../PlanChangeVisual';

export default function UpgradePlanModal({
  show,
  onConfirm,
  onCancel,
  disableConfirm,
  newPlan,
  currentPlan,
}: Readonly<ChangePlanModalProps & { disableConfirm: boolean }>) {
  const t = useTranslationBilling('billingPlansPage.changePlanModal');
  return (
    <Modal open={show} onDismiss={onCancel}>
      <Modal.Header
        title={t('upgrade.title', { newPlanName: newPlan?.name })}
      />
      <Modal.Body padding="none">
        <Box display="flex" flexDirection="column" gap="4">
          <Text>{t('upgrade.message', { newPlanName: newPlan?.name })}</Text>
          {currentPlan && newPlan && (
            <Card>
              <PlanChangeVisual firstPlan={currentPlan} secondPlan={newPlan} />
            </Card>
          )}
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel}>{t('cancel')}</Button>
        <SubmitButton isLoading={disableConfirm} onClick={onConfirm}>
          {t('upgrade.confirm')}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
}
